<div class="notifications" [class.notifications--has-notifications]="hasUnreadNotifications$ | async" (click)="openNotificationsModal()">
    <ng-container *ngIf="unreadCount$ | async as count">
        <div *ngIf="count > 0" class="notifications__count">{{ count }}</div>
    </ng-container>
</div>



